<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="600px"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          text
          rounded-lg
          color="lightAccent"
          class="px-0"
          height="21px"
          :small="$vuetify.breakpoint.md || $vuetify.breakpoint.sm"
          :x-small="$vuetify.breakpoint.xs"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            class="mr-2"
            size="21"
          >
            $bookList
          </v-icon>
          <span class="quaternaryText--text text-subtitle-2">
            {{ $t("bookList.addToList") }}
          </span>
        </v-btn>
      </template>
      <v-card
        tile
        class="fill-height filter-dialog"
        color="lightestAccent"
      >
        <v-card-title
          class="filter-header-container has-box-shadow pa-3"
        >
          <h2>{{ $t("bookList.manageLists") }}</h2>
          <v-spacer />
          <v-btn
            icon
            color="primaryText"
            @click="toggleDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <add-to-book-list-form
            :book-id="bookId"
            @onCompleted="onCompleted"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <success-snackbar
      v-model="snackbar"
      :message="snackbarMessage"
    />
  </div>
</template>

<script>
import AddToBookListForm from '@/components/AddToBookListForm';
import SuccessSnackbar from '@/components/SuccessSnackbar';

export default {
  name: "AddToBookListModal",
  components: { 
    AddToBookListForm,
    SuccessSnackbar,
  },
  props: {
    bookId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      snackbarMessage: '',
      snackbar: false,
    }
  },
  methods: {
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    onCompleted(event) {
      this.dialog = false;
      this.snackbarMessage = event;
      this.snackbar = true;
    },
  },
}
</script>

<style scoped>
:deep(.v-dialog.v-dialog--active) {
  border-radius: 0px;
}
</style>